import { QueryHookOptions } from '@apollo/client'
import B2C_GET_ORDER_INVOICE from '@graphql/queries/getOrderInvoice.query'
import { B2CGetOrderInvoiceQuery, B2CGetOrderInvoiceQueryVariables } from 'parkdepot-shared/gql/graphql'
import { useLazyAuthenticatedQuery } from './useAuth'

const useGetOrderInvoice = (opts: QueryHookOptions<B2CGetOrderInvoiceQuery, B2CGetOrderInvoiceQueryVariables>) => {
    return useLazyAuthenticatedQuery({ query: B2C_GET_ORDER_INVOICE, ...opts })
}

export default useGetOrderInvoice
